module.exports = __webpack_public_path__ + "img/leaf.bb8ce7ad.svg";